/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import {
  Loader,
  Icon,
  Popup,
  Segment,
  Header,
  List
} from 'semantic-ui-react';
import axios from 'axios';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import FileSaver from 'file-saver';
import {
  HOW_TO_USE_LINK,
  RESTFUL_API_GUIDE_LINK,
  RESTFUL_API_SAMPLE_LINK,
  OPEN_SOURCE_LICENSE_LINK,
  WEB_SERVICE_LOG_LINK,
  USER_SIGN_IN_OUT_LOG_LINK,
  USER_ACCESS_LOG_LINK,
  SCAN_HISTORY_LINK,
  HOW_TO_USE_LINK_KO,
  HOW_TO_USE_LINK_JA,
  ECLIPSE_GUIDE_LINK,
  ECLIPSE_PLUGIN_LINK,
  NVD_DATA_FEED_LINK,
  CNVD_DATA_FEED_LINK
} from '../../constants/shared';
import { LICENSE_REGEX } from '../../constants/settings';
import api from '../../api';
import combinedIcon from '../../images/components/profile/combined-shape.svg';
import progress from '../../images/icons/progress_ica.gif';
import './About.css';

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isLoadingWs: false,
      isLoadingSign: false,
      isLoadingLog: false,
      isLoadingApi: false,
      isLoadingSample: false,
      isLoadingLicense: false,
      isLoadingScanHistory: false,
      isOpenPopup: false,
      isOpenCnvdPopup: false,
    };

    this.download = this.download.bind(this);
    this.dnHowToUse = this.dnHowToUse.bind(this);
    this.dnApiGuide = this.dnApiGuide.bind(this);
    this.dnSampleCode = this.dnSampleCode.bind(this);
    this.dnOpenSourceLicense = this.dnOpenSourceLicense.bind(this);
    this.dnSystemService = this.dnSystemService.bind(this);
    this.dnUserSignInOut = this.dnUserSignInOut.bind(this);
    this.dnUserAccess = this.dnUserAccess.bind(this);
    this.dnScanHistory = this.dnScanHistory.bind(this);
    this.dnPluginUserManual = this.dnPluginUserManual.bind(this);
    this.dnPlugin = this.dnPlugin.bind(this);
    this.dnUSerManualWithHeadless = this.dnUSerManualWithHeadless.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handleCnvdPopupClose = this.handleCnvdPopupClose.bind(this);
    this.handleCnvdPopupOpen = this.handleCnvdPopupOpen.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isLoading } = this.state;
    const { state } = this.props;

    if (prevState.isLoading !== isLoading && isLoading) {
      state.company.fetchAbout();
    }
  }

  onUpdateLoading() {
    this.setState({
      isLoading: true,
    });
  }

  getExportedReport = (url, fileName) => {
    api.getExportedReport(url)
      .then((data) => {
        const blob = new Blob([data], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, fileName);
        this.setState({
          isLoadingWs: false,
          isLoadingSign: false,
          isLoadingLog: false,
          isLoadingApi: false,
          isLoadingSample: false,
          isLoadingLicense: false,
          isLoadingScanHistory: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoadingWs: false,
          isLoadingSign: false,
          isLoadingLog: false,
          isLoadingApi: false,
          isLoadingSample: false,
          isLoadingLicense: false,
          isLoadingScanHistory: false,
        });
        debugger // eslint-disable-line
      });
  };

  handlePopupOpen = () => {
    this.setState({
      isOpenPopup: true,
      isOpenCnvdPopup: false,
    });
  };

  handlePopupClose = () => {
    this.setState({
      isOpenPopup: false,
      isOpenCnvdPopup: false,
    });
  };

  handleCnvdPopupOpen = () => {
    this.setState({
      isOpenPopup: false,
      isOpenCnvdPopup: true,
    });
  };

  handleCnvdPopupClose = () => {
    this.setState({
      isOpenPopup: false,
      isOpenCnvdPopup: false,
    });
  };

  dnHowToUse() {
    const config = {
      url: HOW_TO_USE_LINK,
      validateStatus(status) {
        return status >= 200 && status < 300;
      },
    };

    const options = {
      method: 'GET',
      headers: {
        accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
      },
      responseType: 'arraybuffer',
      Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
    };

    Object.assign(config, options);
    return new Promise((resolve, reject) => {
      axios(config)
        .then((data) => {
          debugger // eslint-disable-line
          const blob = new Blob([data], { type: 'application/octet-stream' });
          FileSaver.saveAs(blob, 'UserGuide.pdf');
        })
        .catch((err) => {
          console.log(err);
          reject(err.response);
        });
    });
  }

  dnApiGuide() {
    this.download(RESTFUL_API_GUIDE_LINK, 'RESTFulAPI_MANUAL.pdf');
  }

  dnSampleCode() {
    this.download(RESTFUL_API_SAMPLE_LINK, 'RESTFulAPI_SAMPLE_CODE.zip');
  }

  dnOpenSourceLicense() {
    this.download(OPEN_SOURCE_LICENSE_LINK, 'LICENSE.txt');
  }

  dnSystemService() {
    this.download(WEB_SERVICE_LOG_LINK, 'System_Log.zip');
  }

  dnUserSignInOut() {
    this.download(USER_SIGN_IN_OUT_LOG_LINK, 'User_Sign_In_Out_Log.zip');
  }

  dnUserAccess() {
    this.download(USER_ACCESS_LOG_LINK, 'User_Access_Log.zip');
  }

  dnScanHistory() {
    this.download(SCAN_HISTORY_LINK, 'SCAN_HISTORY.zip');
  }

  dnPluginUserManual() {
    this.download(ECLIPSE_GUIDE_LINK, 'clarity_eclipse_plugin.pdf');
  }

  dnPlugin() {
    this.download(ECLIPSE_PLUGIN_LINK, 'clarity_eclipse_plugin.jar');
  }

  dnUSerManualWithHeadless() {
    api
      .getUSerManualWithHeadless()
      .then((res) => {
        const blob = new Blob([res], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'UserGuide_for_HeadlessMode.pdf');
      })
      .catch((err) => {
        console.log(err);
      });
  }

  download(url, fileName) {
    if (url === WEB_SERVICE_LOG_LINK) {
      this.setState({
        isLoadingWs: true,
      }, () => {
        this.getExportedReport(url, fileName);
      });
    } else if (url === USER_SIGN_IN_OUT_LOG_LINK) {
      this.setState({
        isLoadingSign: true,
      }, () => {
        this.getExportedReport(url, fileName);
      });
    } else if (url === USER_ACCESS_LOG_LINK) {
      this.setState({
        isLoadingLog: true,
      }, () => {
        this.getExportedReport(url, fileName);
      });
    } else if (url === RESTFUL_API_GUIDE_LINK) {
      this.setState({
        isLoadingApi: true,
      }, () => {
        this.getExportedReport(url, fileName);
      });
    } else if (url === RESTFUL_API_SAMPLE_LINK) {
      this.setState({
        isLoadingSample: true,
      }, () => {
        this.getExportedReport(url, fileName);
      });
    } else if (url === OPEN_SOURCE_LICENSE_LINK) {
      this.setState({
        isLoadingLicense: true,
      }, () => {
        this.getExportedReport(url, fileName);
      });
    } else if (url === SCAN_HISTORY_LINK) {
      this.setState({
        isLoadingScanHistory: true,
      }, () => {
        this.getExportedReport(url, fileName);
      });
    } else {
      this.getExportedReport(url, fileName);
    }
  }

  renderValue = () => {
    const { savedLicenseKey } = this.props.state.company.about;
    if (savedLicenseKey) {
      return (
        savedLicenseKey.match(LICENSE_REGEX).join('-')
      );
    }
    return 'N/A';
  };

  render() {
    const {
      clarityVersion,
      clarityOssVersion,
      clarityNvdVersion,
      databaseVersion,
      licenseStartDate,
      licenseExpirationDate,
      allowShowSystemLog,
      cveIdCount,
      cveUpdatedDate,
      cnvdUpdatedDate,
      clarityCnvdVersion,
    } = this.props.state.company.about;

    const {
      isLoadingWs,
      isLoadingSign,
      isLoadingLog,
      isLoadingApi,
      isLoadingSample,
      isLoadingLicense,
      isLoadingScanHistory,
      isOpenPopup,
      isOpenCnvdPopup
    } = this.state;

    const { t } = this.props;
    const currentLocale = localStorage.getItem('i18nextLng');

    const renderIfReady = (element) => {
      return (
        this.props.state.company.isLoading || this.props.state.user.isLoading
          ? (
            <div style={{ paddingTop: '5%' }}>
              <Loader size="big" inline="centered" style={{ display: 'block' }}>
                {t('modal.message.loading')}
              </Loader>
            </div>
          )
          : (element)
      );
    };

    const securityDbInfo = (
      <Segment
        className="security_db_info"
      >
        <Header as="h4" dividing>
          <Icon name="info circle" />
          {t('about.message.vuln_data_overview_title')}
        </Header>
        <p>{t('about.message.vuln_data_overview_description')}</p>
        <List relaxed>
          <div className="list_item">
            <List.Item>
              <Icon name="linkify" />
              <strong>{t('about.message.vuln_data_overview_sourceTitle')}</strong>
            &nbsp;
              <a className="link" href={NVD_DATA_FEED_LINK} target="_blank" rel="noopener noreferrer">
                {t('about.message.vuln_data_overview_linkText')}
              </a>
            </List.Item>
          </div>
        </List>
      </Segment>
    );

    const cnvdInfoText = (
      <Segment
        className="security_db_info"
      >
        <Header as="h4" dividing>
          <Icon name="info circle" />
          {t('about.message.cnvd_data_overview_title')}
        </Header>
        <p>{t('about.message.cnvd_data_overview_description')}</p>
        <List relaxed>
          <div className="list_item">
            <List.Item>
              <Icon name="linkify" />
              <strong>{t('about.message.vuln_data_overview_sourceTitle')}</strong>
            &nbsp;
              <a className="link" href={CNVD_DATA_FEED_LINK} target="_blank" rel="noopener noreferrer">
                {t('about.message.cnvd_data_overview_linkText')}
              </a>
            </List.Item>
          </div>
        </List>
      </Segment>
    );

    return (
      <div className="contents">
        <div className="content">
          <div className="profile_content profile_about_content">
            <h2>{t('about.menu.about')}</h2>
            {
              renderIfReady(
                <div className="profile_content_area">
                  <div className="about_info">
                    <div className="about_info_item_wrap">
                      <div className="about_info_item left">
                        <h3>{t('about.menu.clarity_version')}</h3>
                        <div className="about_info_item_content">
                          <div className="text_box">
                            {clarityVersion || 'N/A'}
                          </div>
                        </div>
                      </div>
                      {
                        this.props.state.user.isAdminOnly ? (
                          <div className="about_info_item right ">
                            <h3>{t('about.menu.license_key')}</h3>
                            <div className="about_info_item_content">
                              <div className="text_box">
                                {this.renderValue()}
                              </div>
                            </div>
                          </div>
                        ) : null
                      }
                    </div>

                    <div className="about_info_item_wrap">
                      <div className="about_info_item left">
                        <h3>{t('about.menu.oss_db_version')}</h3>
                        <div className="about_info_item_content">
                          <div className="text_box">
                            {clarityOssVersion || 'N/A'}
                          </div>
                        </div>
                      </div>
                      {
                        this.props.state.user.isAdminOnly ? (
                          <div className="about_info_item right ">
                            <h3>{t('about.menu.validation_date')}</h3>
                            <div className="about_info_item_content">
                              <div className="text_box">
                                {licenseStartDate && licenseExpirationDate
                                  ? `${licenseStartDate} ~ ${licenseExpirationDate}`
                                  : 'N/A'}
                              </div>
                            </div>
                          </div>
                        ) : null
                      }
                    </div>

                    <div className="about_info_item_wrap">
                      <div className="about_info_item left">
                        <h3>{t('about.menu.clarity_nvd_version')}</h3>
                        <div className="about_info_item_content">
                          <div className="text_box">
                            {clarityNvdVersion || 'N/A'}
                          </div>
                        </div>
                      </div>
                      <div className="about_info_item right ">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <h3 style={{ marginRight: '8px' }}>{t('about.menu.clarity_nvd_info')}</h3>
                          <Popup
                            trigger={(
                              <Icon
                                name="question circle"
                                size="large"
                                style={{ cursor: 'pointer', color: '#7434fe' }}
                                onMouseEnter={this.handlePopupOpen}
                                onClick={this.handlePopupOpen}
                              />
                            )}
                            open={isOpenPopup}
                            onClose={this.handlePopupClose}
                            on="click"
                            content={securityDbInfo}
                            position="top left"
                            wide="very"
                          />
                        </div>
                        <div className="about_info_item_content">
                          <div className="text_box">
                            {cveUpdatedDate || 'N/A'}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="about_info_item_wrap">
                      <div className="about_info_item left">
                        <h3>{t('about.menu.clarity_cnvd_version')}</h3>
                        <div className="about_info_item_content">
                          <div className="text_box">
                            {clarityCnvdVersion || 'N/A'}
                          </div>
                        </div>
                      </div>
                      <div className="about_info_item right ">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <h3 style={{ marginRight: '8px' }}>{t('about.menu.clarity_cnvd_info')}</h3>
                          <Popup
                            trigger={(
                              <Icon
                                name="question circle"
                                size="large"
                                style={{ cursor: 'pointer', color: '#7434fe' }}
                                onMouseEnter={this.handleCnvdPopupOpen}
                                onClick={this.handleCnvdPopupOpen}
                              />
                            )}
                            open={isOpenCnvdPopup}
                            onClose={this.handleCnvdPopupClose}
                            on="click"
                            content={cnvdInfoText}
                            position="top left"
                            wide="very"
                          />
                        </div>
                        <div className="about_info_item_content">
                          <div className="text_box">
                            {cnvdUpdatedDate || 'N/A'}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="about_info_item_wrap">
                      <div className="about_info_item left ">
                        <h3>{t('about.menu.total_cve_count')}</h3>
                        <div className="about_info_item_content">
                          <div className="text_box">
                            {cveIdCount || 0}
                          </div>
                        </div>
                      </div>
                      <div className="about_info_item right">
                        <h3>{t('about.menu.sql')}</h3>
                        <div className="about_info_item_content">
                          <div className="text_box">
                            {databaseVersion}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/**
                    <div className="about_info_item_wrap">
                      <div className="about_info_item">
                        <h3>Total Usage <em>{quotaPeriodSpent} / {quotaPeriodSet}</em></h3>
                        <div className="about_info_item_content">
                          <div className="progress">
                            {
                              quotaPeriodSet !== 'Unlimited' ? (
                                <div>
                                  <div className="value">{Math.round(quotaPeriodSpent / quotaPeriodSet) || '-'} %</div>
                                  <div className="bar" style={{ width: `${(quotaPeriodSpent / quotaPeriodSet) * 100 || 0}%` }} />
                                </div>
                              ) : (
                                <div>
                                  <div className="value">Unlimited</div>
                                  <div className="bar" style={{ width: '100%' }} />
                                </div>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="about_info_item_wrap">
                      <div className="about_info_item">
                        <h3>Daily Usage <em>{quotaDailySpent} / {quotaDailySet}</em></h3>
                        <div className="about_info_item_content">
                          <div className="progress">
                            {
                              quotaDailySet !== 'Unlimited' ? (
                                <div>
                                  <div className="value">{Math.round(quotaDailySpent / quotaDailySet) || '-'} %</div>
                                  <div className="bar" style={{ width: `${(quotaDailySpent / quotaDailySet) * 100 || 0}%` }} />
                                </div>
                              ) : (
                                <div>
                                  <div className="value">Unlimited</div>
                                  <div className="bar" style={{ width: '100%' }} />
                                </div>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  */}
                  </div>
                </div>
              )
            }

            <div className="line" />
            <h2>{t('about.menu.how_to_use')}</h2>
            <div className="profile_content_area">
              <div className="about_info">
                <div className="about_info_item_wrap">
                  <div className="about_info_item ">
                    <h3>{t('about.menu.clarity_user')}</h3>
                    <div className="about_info_item_content">
                      {
                        currentLocale === 'ja' && (

                          <a
                            className="text_box"
                            href={HOW_TO_USE_LINK_JA}
                            target="_blank"
                            rel="noreferrer noopener"
                            style={{ cursor: 'pointer' }}
                          >
                            <img src={combinedIcon} alt="" className="icon" />
                            {t('about.menu.user_manual')}
                          </a>
                        )
                      }
                      {
                        currentLocale === 'kr'
                          && (
                            <a
                              className="text_box"
                              href={HOW_TO_USE_LINK_KO}
                              target="_blank"
                              rel="noreferrer noopener"
                              style={{ cursor: 'pointer' }}
                            >
                              <img src={combinedIcon} alt="" className="icon" />
                              {t('about.menu.user_manual')}
                            </a>
                          )
                      }
                      {
                        currentLocale === 'en'
                        && (
                          <a
                            className="text_box"
                            href={HOW_TO_USE_LINK}
                            target="_blank"
                            rel="noreferrer noopener"
                            style={{ cursor: 'pointer' }}
                          >
                            <img src={combinedIcon} alt="" className="icon" />
                            {t('about.menu.user_manual')}
                          </a>
                        )
                      }
                    </div>
                    <div className="about_info_item_content">
                      <a
                        className="text_box"
                        onClick={this.dnUSerManualWithHeadless}
                        onKeyUp={this.dnUSerManualWithHeadless}
                        style={{ cursor: 'pointer' }}
                      >
                        <img src={combinedIcon} alt="" className="icon" />
                        {t('about.menu.headless_mode_manual')}
                      </a>
                    </div>
                  </div>
                </div>

                <div className="about_info_item_wrap">
                  <div className="about_info_item ">
                    <h3>{t('about.menu.clarity_developer')}</h3>
                    <div className="about_info_item_content">
                      {
                        !isLoadingApi ? (
                          <div
                            className="text_box"
                            style={{ cursor: 'pointer' }}
                            onClick={this.dnApiGuide}
                            onKeyUp={this.dnApiGuide}
                          >
                            <Icon className="download" />
                            {t('about.menu.restful_api_doc')}
                          </div>
                        ) : (
                          <div
                            className="text_box"
                          >
                            <img
                              src={progress}
                              role="presentation"
                              style={{
                                width: 14,
                                height: 14,
                                margin: '0 10px 0 0',
                                verticalAlign: 'middle',
                              }}
                              alt=""
                            />
                            {t('about.menu.restful_api_doc')}
                          </div>
                        )
                      }
                      {
                        !isLoadingSample ? (
                          <div
                            className="text_box"
                            style={{ cursor: 'pointer' }}
                            onClick={this.dnSampleCode}
                            onKeyUp={this.dnSampleCode}
                          >
                            <Icon className="download" />
                            {t('about.menu.restful_api_sample_code')}
                          </div>
                        ) : (
                          <div
                            className="text_box"
                          >
                            <img
                              src={progress}
                              role="presentation"
                              style={{
                                width: 14,
                                height: 14,
                                margin: '0 10px 0 0',
                                verticalAlign: 'middle',
                              }}
                              alt=""
                            />
                            {t('about.menu.restful_api_sample_code')}
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>

                <div className="about_info_item_wrap">
                  <div className="about_info_item ">
                    <h3>{t('about.menu.clarity_eclipes_plugin')}</h3>
                    <div className="about_info_item_content">
                      <div
                        className="text_box"
                        style={{ cursor: 'pointer' }}
                        onClick={this.dnPluginUserManual}
                        onKeyUp={this.dnPluginUserManual}
                      >
                        <Icon className="download" />
                        {t('about.menu.user_manual')}
                      </div>
                      <div
                        className="text_box"
                        style={{ cursor: 'pointer' }}
                        onClick={this.dnPlugin}
                        onKeyUp={this.dnPlugin}
                      >
                        <Icon className="download" />
                        {t('about.menu.clarity_eclipes_plugin_donwload')}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="about_info_item_wrap">
                  <div className="about_info_item ">
                    <h3>{t('about.menu.open_source')}</h3>
                    <div className="about_info_item_content">
                      {
                        !isLoadingLicense ? (
                          <div
                            className="text_box"
                            style={{ cursor: 'pointer' }}
                            onClick={this.dnOpenSourceLicense}
                            onKeyUp={this.dnOpenSourceLicense}
                          >
                            <Icon className="download" />
                            {t('about.menu.open_source_license')}
                          </div>
                        ) : (
                          <div
                            className="text_box"
                          >
                            <img
                              src={progress}
                              role="presentation"
                              style={{
                                width: 14,
                                height: 14,
                                margin: '0 10px 0 0',
                                verticalAlign: 'middle',
                              }}
                              alt=""
                            />
                            {t('about.menu.open_source_license')}
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {this.props.state.user.isAdmin && <div className="line" />}
            {this.props.state.user.isAdmin && <h2>{t('about.menu.logs')}</h2>}
            {
              this.props.state.user.isAdmin
              && (
                <div className="profile_content_area">
                  <div className="about_info">
                    {
                      allowShowSystemLog
                    && (
                      <div className="about_info_item_wrap">
                        <div className="about_info_item ">
                          <h3>{t('about.menu.system')}</h3>
                          <div className="about_info_item_content">
                            {
                              !isLoadingWs ? (
                                <div
                                  className="text_box"
                                  style={{ cursor: 'pointer' }}
                                  onClick={this.dnSystemService}
                                  onKeyUp={this.dnSystemService}
                                >
                                  <Icon className="download" />
                                  {t('about.menu.web_service')}
                                </div>
                              ) : (
                                <div
                                  className="text_box"
                                >
                                  <img
                                    src={progress}
                                    role="presentation"
                                    style={{
                                      width: 14,
                                      height: 14,
                                      margin: '0 10px 0 0',
                                      verticalAlign: 'middle',
                                    }}
                                    alt=""
                                  />
                                  {t('about.menu.web_service')}
                                </div>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    )
                    }
                    <div className="about_info_item_wrap">
                      <div className="about_info_item ">
                        <h3>{t('about.menu.user')}</h3>
                        <div className="about_info_item_content">
                          {
                            !isLoadingSign ? (
                              <div
                                className="text_box"
                                style={{ cursor: 'pointer' }}
                                onClick={this.dnUserSignInOut}
                                onKeyUp={this.dnUserSignInOut}
                              >
                                <Icon className="download" />
                                {t('about.menu.sign_in_out_logs')}
                              </div>
                            ) : (
                              <div
                                className="text_box"
                              >
                                <img
                                  src={progress}
                                  role="presentation"
                                  style={{
                                    width: 14,
                                    height: 14,
                                    margin: '0 10px 0 0',
                                    verticalAlign: 'middle',
                                  }}
                                  alt=""
                                />
                                {t('about.menu.sign_in_out_logs')}
                              </div>
                            )
                          }
                          {
                            !isLoadingLog ? (
                              <div
                                className="text_box"
                                style={{ cursor: 'pointer' }}
                                onClick={this.dnUserAccess}
                                onKeyUp={this.dnUserAccess}
                              >
                                <Icon className="download" />
                                {t('about.menu.access_logs')}
                              </div>
                            ) : (
                              <div
                                className="text_box"
                              >
                                <img
                                  src={progress}
                                  role="presentation"
                                  style={{
                                    width: 14,
                                    height: 14,
                                    margin: '0 10px 0 0',
                                    verticalAlign: 'middle',
                                  }}
                                  alt=""
                                />
                                {t('about.menu.access_logs')}
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </div>
                    <div className="about_info_item_wrap">
                      <div className="about_info_item ">
                        <h3>{t('about.menu.result')}</h3>
                        <div className="about_info_item_content">
                          {
                            !isLoadingScanHistory ? (
                              <div
                                className="text_box"
                                style={{ cursor: 'pointer' }}
                                onClick={this.dnScanHistory}
                                onKeyUp={this.dnScanHistory}
                              >
                                <Icon className="download" />
                                {t('about.menu.scan_history')}
                              </div>
                            ) : (
                              <div
                                className="text_box"
                              >
                                <img
                                  src={progress}
                                  role="presentation"
                                  style={{
                                    width: 14,
                                    height: 14,
                                    margin: '0 10px 0 0',
                                    verticalAlign: 'middle',
                                  }}
                                  alt=""
                                />
                                {t('about.menu.scan_history')}
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

            <div className="line" />

            <h2>{t('about.menu.contact_us')}</h2>
            <div className="profile_content_area">
              <div className="about_info">
                <div className="about_info_item_wrap">
                  <div className="about_info_item ">
                    <h3>{t('about.menu.address')}</h3>
                    <div className="about_info_item_content">
                      <div className="text_box">
                        {t('company_info.address')}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="about_info_item_wrap">
                  <div className="about_info_item ">
                    <h3>{t('about.menu.phone')}</h3>
                    <div className="about_info_item_content">
                      <div className="text_box">
                        {t('company_info.phone')}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="about_info_item_wrap">
                  <div className="about_info_item ">
                    <h3>{t('about.menu.fax')}</h3>
                    <div className="about_info_item_content">
                      <div className="text_box">
                        {t('company_info.fax')}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="about_info_item_wrap">
                  <div className="about_info_item ">
                    <h3>{t('about.menu.email')}</h3>
                    <div className="about_info_item_content">
                      <div className="text_box">
                        {t('about.message.company_info_inquiries')}
                        <a href="mailto:info@insignary.com">info@insignary.com</a>
                      </div>
                      <div className="text_box">
                        {t('about.message.company_info_sales')}
                        <a href="mailto:sales@insignary.com">sales@insignary.com</a>
                      </div>
                      <div className="text_box">
                        {t('about.message.company_info_support')}
                        <a href="mailto:support@insignary.com">support@insignary.com</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default (withTranslation()(inject('state')(observer(About))));
